import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TaxAttributesComponent } from '../tax-attributes.component';

@Component({
    selector: 'app-tax-attributes-entity-create-form',
    templateUrl: './tax-attributes-entity-create-form.component.html',
    styleUrls: ['../tax-attributes.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TaxAttributesEntityCreateFormComponent {
  @Input() ctx!: TaxAttributesComponent;
}
